import { Injectable } from '@angular/core';
import { AssistanceDirectCharge } from './assistanceDirectCharge.model';
import { Globle } from 'src/assets/globle';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AssisDirctChargeService {

  constructor(private http: HttpClient, private global: Globle) {


  }

  getByUser(userid: string) {
    return this.http.get<AssistanceDirectCharge[]>(this.global.APIURLV2 +
      "assistancecategorypermission/getbyuser/" + userid);
  }

  Create(obj: any) {
    return this.http.post<any>(this.global.APIURLV2 + "assistancecategorypermission/create", obj);
  }
}
